// extracted by mini-css-extract-plugin
export default {"root":"NavBar_root__2NeTy","links":"NavBar_links__nab8c","link":"NavBar_link__-Ibux","current":"NavBar_current__-C1su"};